import React, { useContext, useState, useEffect } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { Context as AuthContext } from 'contexts/auth';
import { Context as CompanyContext } from 'contexts/company';
import { Config } from 'configs';
import { apiActionChooser } from 'utils/apiActionChooser';
import { resourceRequest } from 'api/client/requests';
import { ProductScheduleForm } from './scheduleForm';

export const ProductsAddNewSchedule = ({ itemData, restaurants, selectedRestaurants }) => {
  const { state: auth } = useContext(AuthContext);
  const { getByFilter } = useContext(CompanyContext);

  const [schedules, setSchedules] = useState([]);
  const [schedulesGot, setSchedulesGot] = useState(false);

  useEffect(() => {
    const fetchSchedules = async () => {
      let response;

      await apiActionChooser(
        auth.company?.company,
        async () => {
          response = await getByFilter({
            collectionName: Config.DATA.COLLECTIONS.PRODUCT_SCHEDULE,
            filter: `{ "product": ObjectId("${itemData?._id}") }`,
            token: auth.token,
          });
        },
        async () => {
          response = await resourceRequest({
            data: {
              resource: 'AdminProductSchedule',
              filter: JSON.stringify({ product: { $oid: itemData?._id } }),
            },
            action: 'find',
          });
        },
      );

      if (response && response.result && response.result.length > 0) {
        setSchedules(response?.result);
      }
    };

    if (itemData?._id && !schedulesGot) {
      setSchedulesGot(true);
      fetchSchedules();
    }
  }, [itemData]);

  return (
    <div>
      <div className="shadow sm:rounded-md sm:overflow-hidden">
        <div className="bg-white py-6 px-4 space-y-6 sm:p-6">

          <div className="flex flex-row flex-wrap justify-between items-center">
            <div>
              <h3 className="text-lg leading-6 font-medium text-gray-900">Schedule</h3>
              <p className="mt-1 text-sm text-gray-500">Your product scheduling</p>
            </div>
            <div className="py-3 text-right">
              <button
                type="button"
                onClick={() => {
                  setSchedules((prev) => {
                    return [...prev, { localId: uuidv4() }];
                  });
                }}
                className="bg-indigo-600 border border-transparent rounded-md shadow-sm py-2 px-4 inline-flex justify-center text-sm font-medium text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
              >
                Add schedule
              </button>
            </div>
          </div>

        </div>
      </div>
      {schedules && schedules.length > 0 && schedules.map((schedule, ind) => (
        <div className="mt-6" key={`${schedule._id || schedule.localId}`}>
          <ProductScheduleForm
            product={itemData}
            itemData={schedule}
            restaurants={restaurants}
            allowedRestaurants={selectedRestaurants}
            onSaved={(val) => {
              setSchedules((prev) => {
                const newArray = [...prev];

                newArray[ind] = val;
                return newArray;
              });
            }}
            onDeleted={() => {
              setSchedules((prev) => {
                const newArray = [...prev];

                newArray[ind] = null;
                return newArray.filter((x) => !!x);
              });
            }}
          />
        </div>
      ))}
    </div>
  );
};
